<template lang="pug">
    .preloader(v-if='showPreloader')
        .preloader__progress(:class='{animate: pageLoaded}')
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'Preloader',
    data() {
        return {
            showPreloader: true
        };
    },

    computed: {
        ...mapGetters(['pageLoaded'])
    },

    beforeMount() {
        this.showPreloader = this.$route.name && this.$route.name === 'Profile' ? false : true;
    }
};
</script>

<style lang="scss">
@keyframes runPseudoPreloader {
    0% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(0);
    }
}

.preloader {
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
    width: 100%;
    height: 100vh;
    height: calc(var(--vh) * 100);
    z-index: 18;

    &__progress {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--color-bg-dark);
        transform-origin: 100% 0;
        transform: scaleX(1);

        &.animate {
            animation: runPseudoPreloader 2s ease-in-out;
            animation-fill-mode: forwards;
        }
    }
}
</style>
